import loadable from '@loadable/component';

export const ExpertPage = loadable(/* #__LOADABLE__ */ () => import('./ExpertPage'));
